import { render } from "./Random.vue?vue&type=template&id=3627e554&scoped=true"
import script from "./Random.vue?vue&type=script&lang=js"
export * from "./Random.vue?vue&type=script&lang=js"

import "./Random.vue?vue&type=style&index=0&id=3627e554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3627e554"]])

export default __exports__